"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTotalJackpot = void 0;
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var currencies_1 = require("../currencies");
var useTotalJackpot = function () {
    var currentCurrency = (0, currencies_1.useCurrentCurrency)();
    var _a = (0, useQuery_1.useQuery)({
        payload: {
            currency: currentCurrency,
        },
        path: keys_1.JACKPOT_TOTAL,
    }), data = _a.data, isLoading = _a.isLoading, error = _a.error;
    return {
        data: data === null || data === void 0 ? void 0 : data.data,
        isLoading: isLoading,
        error: error,
    };
};
exports.useTotalJackpot = useTotalJackpot;
